/* eslint-disable */
import { Fragment, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../app/store';
import { classNames } from '../../../utils/classNames';
import TypingMessage from '../../../components/shared/typing-message/TypingMessage';
import moment from 'moment';
// import ReactMarkdown from 'react-markdown';
import MessageActions from '../../../components/message-actions/MessageActions';
// import remarkGfm from 'remark-gfm';
// import rehypeHighlight from 'rehype-highlight';
import { useAppDispatch } from '../../../app/hooks';
import { useGetTopicChatsMutation } from '../../../store/chatbox/chatboxApi';
import { setChatMessages, setChatId } from '../../../store/slices/chats.slice';
import { useParams } from 'react-router-dom';
import { useGetCurrentUserQuery } from '../../../store/user/userApi';
import AnimatedDiv from '../../../components/shared/animated-div/AnimatedDiv';
import VideoBg from '../../../components/shared/video-bg/VideoBg';
import { convertMarkdownToHTML } from '../../../utils/convertMarkdownToHTML';
import S3ExcelPreview from '../../../components/shared/s3-preview/S3ExcelPreview';
import S3PdfPreview from '../../../components/shared/s3-preview/S3PdfPreview';
import PendingChat from './PendingChat';
import { cleanBrTags } from '../../../utils/clearNrTags';
// import ReactMarkdown from 'react-markdown';
// import remarkGfm from 'remark-gfm';
// import rehypeHighlight from 'rehype-highlight';

const ChatContent = ({
	isFromHomepage,
	intro
}: {
	isFromHomepage?: boolean,
	intro?: boolean
}) => {
	const { id } = useParams();
	const { data: userInfo } = useGetCurrentUserQuery();
	const [chatTopicChat, { isLoading }] = useGetTopicChatsMutation()
	const dispatch = useAppDispatch();
	const chatEndRef = useRef<HTMLDivElement>(null);
	const audioRef = useRef<HTMLAudioElement | { pause: () => void; paused: boolean; currentTime: number } | null>(null);

	const getChats = async () => {
		const { data } = await chatTopicChat({ topic: id || '', userId: userInfo?.id || '' }).unwrap();
		const chats = Array.isArray(data.chats) ? data.chats : data.chats ? [data.chats] : [];
		dispatch(setChatMessages(chats));
		if (data.topics) dispatch(setChatId(data.topics));
	}

	const scrollToBottom = () => setTimeout(() => {
		const container = chatEndRef.current;
		if (!container) return;
		container.scrollIntoView({ behavior: 'smooth' });
	}, 500)


	useEffect(() => {
		if (id && userInfo?.id) {
			getChats();
			dispatch(setChatId(id || ''))
		} else {
			if (!isFromHomepage)
				dispatch(setChatMessages([]))
		}
		if (!intro) setTimeout(() => scrollToBottom(), 200)

	}, [id, userInfo?.id])

	const { messages } = useSelector(
		(state: RootState) => state.chats
	);

	useEffect(() => {
		if (!intro) scrollToBottom()
	}, []);

	const lastUserMessageHeight = document.querySelectorAll('.user-section')[document.querySelectorAll('.user-section').length - 1]?.clientHeight || 0

	return (
		<div className={classNames('h-[80vh] md:h-[calc(100vh-350px)] w-full overflow-auto bg-gray-50 flex flex-col text-primary-dark dark:bg-black mb-5 rounded-xl md:max-w-[760px] mx-auto', messages.length === 0 ? 'p-0' : 'p-5 border-2 border-gray-200 dark:border-transparent')}>
			{isLoading && <div className='w-full h-full flex justify-center items-center'>
				<div className='flex items-center gap-1 typing'><span /><span /><span /></div>
			</div>}
			{(messages.length === 0 && !isLoading) &&
				<div className='flex flex-wrap w-full h-full items-center justify-center'>
					<div className="relative w-full h-full rounded-xl overflow-hidden z-0 flex flex-col">
					{userInfo?.logoUrl ? 
						<VideoBg url="/video/white-abstract-fabric-background.mp4" /> : 
						<img src="/images/athens-bar.jpg" alt="athens" className="absolute w-full h-full object-cover top-0 left-0 p-0 -z-10" />
					}
						<div className="absolute w-full h-full object-cover top-0 left-0 p-0 -z-10 bg-white bg-opacity-80" />
						<div className='m-auto'>
							<img src={userInfo?.logoUrl || "/svg/logo.svg"} className={classNames('m-auto w-80', userInfo?.logoUrl ? 'rounded-full' : '')} alt="hotel" />
							<p className='font-normal text-base text-gray-800 dark:text-primary-darkMode mt-5 text-center'>Ask questions. Let the magic happen</p>
						</div>
					</div>
				</div>
			}
			{messages.map(
				(conversation, index: number) => (
					<Fragment key={conversation?._id}>
						<div className='my-2 flex flex-col'>
							{!conversation.user ?
								<div 
									className='w-full flex flex-row'
									style={{minHeight: (messages.length - 1 === index && conversation.requestId && messages.length > 2) ? `calc(100vh - ${320 + lastUserMessageHeight}px)` : ''}}
									>
									<div className='pt-4'>
										<img alt='avatar' width={34} height={34} className='rounded-full mr-2' src={conversation.agent?.imageUrl || '/svg/auth/sofia.svg'} />
									</div>
									<div className='max-w-[95%] rounded-2xl p-4'>
										<div>
											{conversation.files && conversation.files.map(file => <div key={file.name} className='w-20 h-20 bg-gray-100 border border-gray-200 m-2 relative'>
												<img src={file.url} className='w-full h-full object-cover' alt={file.name} />
											</div>)}
										</div>
										{/* {(conversation.message.length && (messages.length - 1 === index && conversation.instantReply)) ? */}
											{(conversation.message.length &&  (messages.length - 1 === index)) ?
											// {conversation.message ?
											<TypingMessage key={conversation._id || conversation.requestId} chatId={conversation._id || conversation.topic} topicId={conversation.topic} message={cleanBrTags(conversation.message)} typingSpeed={500} audioRef={audioRef} />
											: <AnimatedDiv>
												<>
													<div
														className="whitespace-pre-wrap break-words dark:text-white text-sm content-item"
														dangerouslySetInnerHTML={{ __html: conversation?.message ? convertMarkdownToHTML(cleanBrTags(conversation?.message)) : '' }}
													/>
													{!!(conversation._id && conversation.message.length) &&
														<MessageActions
															chatId={conversation._id}
															message={conversation.message}
															liked={conversation.liked}
															disliked={conversation.disliked}
															favorite={conversation.favorite}
															topicId={conversation.topic}
															isIssue={conversation.isIssue}
															audioRef={audioRef}
															clarify={conversation.clarify}
															showOptions={conversation.clarify || messages.length - 1 === index}
														/>}
												</>
											</AnimatedDiv>
										}
										{/* {conversation.type === 'pending' && <div className='flex items-center gap-1 typing pt-3'><span /><span /><span /></div>} */}
										{conversation.type === 'pending' && <PendingChat />}
									</div>
								</div>
								:
								!conversation.clarify && <>
									<div className='flex flex-wrap ml-auto -mr-2'>
										{conversation.files && [...conversation.files].map(file => 
										<div key={file.name} className='w-60 max-h-48 bg-gray-100 border border-gray-200 m-2 relative'>
											{(file.name.includes('.pdf')) ?
											<>
												<S3PdfPreview pdfUrl={file.url} />
											</> :
											(file.name.includes('.xlsx') || file.name.includes('.csv')) ? <>
												<S3ExcelPreview s3Url={file.url} />
											</> :
											<img src={file.url} className='w-full h-full object-cover' alt={file.name} />
											}
										</div>)
										}
									</div>
									<div className={classNames('bg-gray-200 dark:bg-bgColor-darkMode max-w-[90%] text-gray-900 dark:text-primary-darkMode rounded-2xl p-4 ml-auto user-section text-sm',
										//  conversation.type === 'pending' ? 'opacity-50': '',
										conversation.type === 'error' ? 'border-2 border-red-500 opacity-60' : ''
									)}
									>
										<AnimatedDiv>
											<>
												<div className='w-full break-words'>{convertMarkdownToHTML(cleanBrTags(conversation?.message))}</div>
												{!!conversation.updatedAt && <p className='text-gray-400 dark:text-primary-darkMode text-[10px] font-semibold text-right'>{moment(conversation.updatedAt).format('h:mm A')}</p>}
											</>
										</AnimatedDiv>
									</div>
								</>
							}
						</div>
					</Fragment>
				)
			)}
			<div id='chatEnd' ref={chatEndRef} />
		</div>
	)
}

export default ChatContent;